// extracted by mini-css-extract-plugin
export default {"skipLinkItem":"skip-link-skipLinkItem--3e6cf","skipLink":"skip-link-skipLink--05237"};